module.exports = __webpack_public_path__ + "media/images/index_bg-cd9a19c2.png";